import { useQuery } from "@tanstack/react-query";
import { deviceApis } from "../../../../../../shared/apis/device/apis";

export function useDeviceDetails(editId: string | null) {
  const { data: dispatchedDeviceDetail } = useQuery(
    ["getDispatchedDeviceDetail", editId],
    () => deviceApis.shipment.getDispatchedDeviceDetail({ id: Number(editId) }),
    {
      select: (data) => data.data,
      enabled: !!editId,
    }
  );

  return {
    dispatchedDeviceDetail,
  };
}
